module.exports = __webpack_public_path__ + "9c3de41ba9bf87e8830253d93a6120c7.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/news/harpers-bazaar/harpers-bazaar-bride-2015-1.jpg
 ** module id = 462
 ** module chunks = 0
 **/